export default {"src":"/_next/static/media/0x7f5c764cbc14f9669b88837ca1490cca17c31607.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};